<template>
    <div class="locale-changer">
        <div class="locale-changer">
            <div v-for="(lang, i) in langs" :key="`Lang${i}`" class="locale" :class="{ 'active' : $i18n.locale === lang }" @click="changeLocale(lang)">
                <label>{{ lang }}</label>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'language-changer-flat',
    computed: {
        langs() {
            return this.$i18n.availableLocales
        }
    },
    methods: {
        changeLocale: function(locale) {
            this.$i18n.locale = locale
        }
    }
}
</script>

<style lang="scss" scoped>
.locale-changer {
    float: right;
    display: flex;
    justify-content: space-evenly;
    height: fit-content;
    align-items: center;

    > .locale {
        padding: 0 10px;
        color: #aaa;
        text-transform: uppercase;
        font-weight: bold;
        font-size: 1.2em;

        &:hover {
            &,
            :deep(*) {
                cursor: pointer;
            }
        }

        &.active {
            color: #0069B4;
        }

        &:not(:last-child) {
            border-right: 1px solid #aaa;
        }
    }
}
</style>